















































































































































































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import orderInfo from './components/OrderInfo.vue'
const loginerModule = namespace('loginer')
const SORT_KEY: any = ['goods_num_send', 'goods_num_recipient']
const TRANSFOR_KEY: string = 'goods_name'
const editInputProp = ['goods_num_send', 'goods_price_send', 'sub_total_send']
const sumCol = ['goods_num', 'goods_num_send', 'goods_num_wait_send', 'sub_total_send']
@Component({
	beforeRouteLeave (to: any, from: any, next: any) {
		if ((this as any).isEdit()) {
			(this as any).$fxConfirm('是否保存当前单据？').then(() => {
				(this as any).setTableUnEdit()
				(this as any).onSaveHandler().then(() => {
					this.$message.success('保存成功')
					next()
				})
			}).catch(() => {
				next()
			})
		} else {
			next()
		}
	},
	components: {
		orderInfo
	}
})
export default class RestaurantOrderDetails extends Vue {
	@loginerModule.State('loginerEmail') private loginerEmail?: string
	private orderData: any = {}
	private isShowPriceFile: boolean = false
	private sendInfo: any = {}
	private orderAttachments: any = []
	private searchKey: string = ''
	private nanArr: any = []
	private numScale: number = 2
	private numPatrn: RegExp = /^(([0-9]+[\.]?[0-9]+)|[0-9])$/
	private options: any = []
	private orderid: string = ''
	private printerVisible: boolean = false
	private isZ5: boolean = false
	private inquiryAmountFlag: boolean = false
	private taxRequired: boolean = false
	private get tableData () {
		if (this.searchKey.trim()) {
			return this.sortGoodDetails(this.transforDetails(this.orderData.details), SORT_KEY[0], SORT_KEY[1])
		} else {
			return this.sortGoodDetails(this.orderData.details, SORT_KEY[0], SORT_KEY[1])
		}
	}
	private created () {
		this.refreshOrderDetails()
	}
	private mounted () {
		(this as any).$refs.fxTable.doLayout()
	}
	private updated () {
		this.$nextTick(() => {
			(this as any).$refs.fxTable.doLayout()
		})
	}
	private isBillState (state: any) {
		return (this as any).$fxStateMiddleware.stateIs('stateQuotes')(state)(this.orderData.bill_state)
	}
	private refreshOrderDetails () {
		return Promise.all([this.getOrderDetails((this as any).$route.query.id), this.getSendInfo()]).then(() => {
			this.getOrderAttachments()
		})
	}
	private onPrintClick (): void {
		const params = (this as any).$route.query.id
		this.orderid = params
		this.printerVisible = true
	}
	private getOrderDetails (id: string): void {
		const params = {
			bill_id: id
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/billWithDetail',
			data: params,
			fullData: true
		}).then((res: any) => {
			const isZ5 = res.otherdata == null ? false : res.otherdata.isZ5
			const forceUploadPermitFlag = res.otherdata && res.otherdata.forceUploadPermitFlag
			const taxRequired = res.otherdata == null ? false : res.otherdata.taxRequired || false
			this.inquiryAmountFlag = res.otherdata == null ? false : res.otherdata.inquiryAmountFlag
			if (!isZ5 && forceUploadPermitFlag === true) {
				this.$message.warning('请上传供货商证照信息！')
				this.$router.replace({path: 'systemSet'})
				return Promise.reject()
			}

			this.isZ5 = isZ5
			this.taxRequired = taxRequired
			this.orderData = res.data
			this.isShowPriceFile = res.otherdata && res.otherdata.isShowPriceFile === true
			this.orderData.details.forEach((e: any) => {
				e.goods_price_sendss = e.goods_price_send
				e.goods_cess = e.goods_cess === null ? '' : e.goods_cess + '%'
			})
			this.numScale = this.orderData.details[0].number_scale || 2
			const arr = this.orderData.goods_cess_array.replace(/,$/, '').split(',')
			arr.filter((item: string) => {
				if (taxRequired && isZ5) {
					return item !== '0'
				}
				return item
			}).map( (e: string) => {
				(this as any).options.push({
					value: e,
					label: e
				})
			})
		})
	}
	private	sendPriceCount (index: number, detailData: any, props: string) {
		this.$nextTick(() => {
			detailData.goods_price_sendss =	detailData.goods_price_send
			this.nanArr = []
			this.onCellInputEnter(arguments, props, index)
		})
	}
	private	sendPriceCountFixed (index: number, detailData: any, props: string) {
		if (!(this.numPatrn.test(detailData.goods_price_send))) {
			this.$message.warning('含税单价只能是正数')
			detailData.goods_price_send = 0.0000
			return false
		}
		if (detailData.goods_price_send > 100000) {
			this.$message.warning('含税单价有效值范围：0~99999')
			detailData.goods_price_send = 0.0000
			return false
		}
	}
	private selectOptions (detailData: any, val: any) {
		detailData.goods_price_send = detailData.goods_price_sendss * (1 + val / 100)
		detailData.goods_price_send = this.toFixed(detailData.goods_price_send)
		detailData.goods_cess = val + '%'
	}
	private selectOptionsFocus (detailData: any, val: any) {
		detailData.good_cess = parseFloat(val)
	}
	private transforDetails (goodDetails: any = []) {
		return goodDetails.filter((item: any) => {
			return item[TRANSFOR_KEY].indexOf(this.searchKey.trim()) >= 0
		})
	}
	private getSendInfo () {
		return (this as any).$fxHttp.requestPost({
			url: '/business/getSendSysUser'
		}).then((res: any) => {
			this.sendInfo = res
		})
	}
	private sortGoodDetails (goodDetails: any = [], sortKeyFirst: string, sortKeySecond: string) {
		return goodDetails.sort((firstItem: any, secondItem: any) => {
			return (firstItem[sortKeyFirst] - firstItem[sortKeyFirst]) < (secondItem[sortKeySecond] - secondItem[sortKeySecond])
		})
	}
	private onTableRowClick (item: any, colum: any, cell: any, event: any) {
		if (!this.isBillState(['agree'])) {
			return false
		}
		let property = colum.property
		if (!editInputProp.includes(property)) {
			property = editInputProp[0]
		}
		this.setTableUnEdit().then(() => {
			item.isEdit = true
			this.$nextTick(() => {
				(this.$refs[`grid-${property}`] as any).focus()
			})
		})
	}
	private onCellInputEnter (arg: any, prop: string, index: number) {
		if (!this.isBillState(['unConfirm'])) {
			return false
		}
		if (prop === 'next') {
			if (index === this.tableData.length - 1) {
				this.onSaveClick()
				return false
			}
			const row = this.tableData[index + 1]
			this.setTableUnEdit().then(() => {
				this.setTableEdit(row, index + 1)
			})
		} else {
			(this.$refs[`grid-${prop}`] as any).focus()
		}
	}
	private setTableEdit (row: any, index: number) {
		(this as any).$set(this.orderData.details[index], 'isEdit', true)
		this.$nextTick(() => {
			(this.$refs[`grid-${editInputProp[0]}`] as any).focus()
		})
	}
	private setTableUnEdit () {
		this.orderData.details.forEach((item: any, index: number) => {
			(this as any).$set(this.orderData.details[index], 'isEdit', false)
		})
		return Promise.resolve()
	}
	private onCellInputDown (arg: any, prop: string, index: number) {
		if (index === this.tableData.length - 1) {
			return false
		}
		const row = this.tableData[index + 1]
		this.setTableUnEdit().then(() => {
			(this as any).$set(this.orderData.details[index + 1], 'isEdit', true)
			this.$nextTick(() => {
				(this.$refs[`grid-${prop}`] as any).focus()
			})
		})
	}
	private onCellInputUp (arg: any, prop: string, index: number) {
		if (index === 0) {
			return false
		}
		this.setTableUnEdit().then(() => {
			(this as any).$set(this.orderData.details[index - 1], 'isEdit', true)
			this.$nextTick(() => {
				(this.$refs[`grid-${prop}`] as any).focus()
			})
		})
	}
	private onSaveClick () {
		if (!this.isEdit()) {
			return false
		}

		let errmsg: any = ''
		errmsg = this.beforeSaveHandler()
		if (!(errmsg === true)) {
			(this as any).$fxAlert(errmsg.join(',') + '。  以上品项，含税单价不能大于参考价')
			return false
		}
		const hasEmptyTax = this.isZ5 && this.orderData.details.some((item) => {
			return item.goods_cess === undefined || item.goods_cess === null || item.goods_cess === ''
		})
		if (hasEmptyTax) {
			this.$message.error('税率不能为空，请修改')
			return false
		}
		const hasZeroTax = this.isZ5 && this.taxRequired && this.orderData.details.some((item) => {
			return item.goods_cess === '0%'
		})
		if (hasZeroTax) {
			this.$message.error('税率不能为0，请修改')
			return false
		}
		this.onSaveHandler().then(() => {
			this.setTableUnEdit()
			this.$message.success('保存成功')
		})
	}
	private beforeSaveHandler () {
		const errs: any = []
		if (this.isZ5) {
			this.orderData.details.map((item: any) => {
				if (parseFloat(item.goods_price_send) > parseFloat(item.reference_price) && parseFloat(item.reference_price) > 0) {
					errs.push(item.goods_name)
				}
			})
			if (errs.length > 0) {
				return errs
			} else {
				return true
			}
		} else {
			return true
		}
	}
	private onSaveHandler () {
		if (!this.isEdit()) {
			return Promise.resolve()
		}
		this.orderData.details.map((item: any) => {
			item.goods_cess = parseFloat(item.goods_cess)
		})
		return (this as any).$fxHttp.requestPost({
			url: '/business/bill/updateWithDetail',
			data: this.orderData
		}).then((res: any) => {
			this.orderData.details.map((item: any) => {
				item.goods_cess = item.goods_cess + '%'
			})
			return Promise.resolve()
		})
	}
	private onConfirmClick () {
		let errmsg: any = ''
		errmsg = this.beforeSaveHandler()
		if (!(errmsg === true)) {
			(this as any).$fxAlert(errmsg.join(',') + '  以上品项，含税单价不能大于参考价')
			return false
		}
		const hasEmptyTax = this.isZ5 && this.orderData.details.some((item) => {
			return item.goods_cess === undefined || item.goods_cess === null || item.goods_cess === ''
		})
		if (hasEmptyTax) {
			this.$message.error('税率不能为空，请修改')
			return false
		}
		const hasZeroTax = this.isZ5 && this.taxRequired && this.orderData.details.some((item) => {
			return item.goods_cess === '0%'
		})
		if (hasZeroTax) {
			this.$message.error('税率不能为0，请修改')
			return false
		}

		(this as any).$fxConfirm('是否确认？').then(() => {
			this.checkTableIsEdit().then(this.onConfirmHandler).then(() => {
				(this as any).$fxMessage.success('成功').then(this.refreshOrderDetails)
			})
		})
	}
	private onConfirmHandler () {
		this.orderData.details.map((item: any) => {
			item.goods_cess = parseFloat(item.goods_cess)
		})
		const params = this.orderData
		params.bill_state = 32
		params.addBatch_flag = false
		return (this as any).$fxHttp.requestPost({
			url: '/business/bill/updateWithDetail',
			data: params
		}).then((res: any) => {
			return Promise.resolve()
		})
	}
	private isEdit () {
		const editArr = this.tableData.map((item: any) => {
			return item.isEdit
		})
		return editArr.some((item: any) => {
			return !!item
		})
	}
	private checkTableIsEdit () {
		return new Promise((resolve: any) => {
			if (this.isEdit()) {
				this.setTableUnEdit()
				this.onSaveHandler().then(resolve)
			} else {
				resolve()
			}
		})
	}
	private onCancelSendClick () {
		(this as any).$fxConfirm('是否确定取消发货？').then(() => {
			this.onCancelSendHandler().then(() => {
				(this as any).$fxMessage.success('取消发货成功').then(this.refreshOrderDetails)
			})
		})
	}
	private onCancelSendHandler () {
		const params = {
			bill_state: 99,
			id: this.orderData.id,
			plateNumber: this.sendInfo.plateNumber,
			sender: this.sendInfo.sender,
			senderPhone: this.sendInfo.senderPhone,
			sysparameter: this.sendInfo.sysparameter,
			addBatch_flag: false
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/bill/updateBillState',
			data: params
		}).then((res: any) => {
			return Promise.resolve()
		})
	}
	private onAgreenClick () {
		(this as any).$fxConfirm('是否同意此单据？').then(() => {
			this.onAgreenHandler().then(() => {
				(this as any).$fxMessage.success('同意单据成功').then(this.refreshOrderDetails)
			})
		})
	}
	private onAgreenHandler () {
		const params = {
			bill_state: 31,
			id: this.orderData.id,
			plateNumber: this.sendInfo.plateNumber,
			sender: this.sendInfo.sender,
			senderPhone: this.sendInfo.senderPhone,
			sysparameter: this.sendInfo.sysparameter,
			addBatch_flag: false
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/bill/updateBillState',
			data: params
		}).then((res: any) => {
			return Promise.resolve()
		})
	}
	private onReturnClick () {
		(this as any).$fxConfirm('是否退回此单据？').then(() => {
			this.onReturnHandler().then(() => {
				(this as any).$fxMessage.success('退回单据成功').then(() => {
					this.$router.go(-1)
				})
			})
		})
	}
	private onReturnHandler () {
		const params = {
			bill_state: 39,
			id: this.orderData.id,
			plateNumber: this.sendInfo.plateNumber,
			sender: this.sendInfo.sender,
			senderPhone: this.sendInfo.senderPhone
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/bill/updateBillState',
			data: params
		}).then((res: any) => {
			return Promise.resolve()
		})
	}
	private onSendExcelClick () {
		if (!this.loginerEmail) {
			(this as any).$fxMessage.warning('用户尚未绑定邮箱')
			return false
		}
		(this as any).$fxConfirm('是否确定将单据导出Excel并发送至绑定邮箱？').then(() => {
			this.onSendExcelHandler()
		})
	}
	private onSendExcelHandler () {
		const params = {
			bill_id: (this as any).$route.query.id
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/8001',
			data: params
		}).then((res: any) => {
			(this as any).$fxMessage.success('邮件发送成功')
		})
	}
	private onImportExcelClick () {
		const hasEmptyTax = this.isZ5 && this.orderData.details.some((item) => {
			return item.goods_cess === undefined || item.goods_cess === null || item.goods_cess === ''
		})
		if (hasEmptyTax) {
			this.$message.error('税率不能为空，请修改')
			return false
		}
		const hasZeroTax = this.isZ5 && this.taxRequired && this.orderData.details.some((item) => {
			return item.goods_cess === '0%'
		})
		if (hasZeroTax) {
			this.$message.error('税率不能为0，请修改')
			return false
		}
		(this as any).$fxConfirm('是否确定导入EXCEL到本单据？').then(() => {
			this.onImportExcelHandler()
		})
	}
	private onImportExcelHandler () {
		this.onSaveHandler().then(() => {
			(this as any).$fxUpload({ type: 'excel' }).then((res: any) => {
				const params = new FormData()
				if ((this as any).$route.query.id) {
					params.append('billId', (this as any).$route.query.id)
				}
				params.append('myFile', res)
				return (this as any).$fxHttp.requestPost({
					url: '/export/importPriceBill',
					data: params
				}).then((ress: any) => {
					if (ress.success) {
						(this as any).$fxMessage.success('导入单据成功').then(this.refreshOrderDetails)
						return Promise.resolve()
					} else {
						(this as any).$fxMessage.error(ress.cause)
					}
				})
			})
		})
	}
	private onExportClick () {
		(this as any).$fxConfirm('是否确定导出本单据？').then(() => {
			this.onExportHandler()
		})
	}
	private onExportHandler () {
		const params = (this as any).$route.query.id
		window.open('/cldEdi/export/exportPriceBill.do?billId=' + params)
	}
	private getSummaries (param: any) {
		const { columns, data } = param
		return columns.map((item: any, index: number) => {
			if (index === 0) {
				return '合计'
			} else if (sumCol.includes(item.property)) {
				return (this as any).$fxUtils.arrSum(data, (sumItem: any) => {
					return sumItem[item.property]
				})
			} else {
				return ''
			}
		})
	}
	private getOrderAttachments () {
		const params = {
			id: this.isZ5 ? (this as any).$route.query.id : this.orderData.trans_bill_id
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/bill/showEnclosure',
			data: params
		}).then((res: any) => {
			this.orderAttachments = res
			return Promise.resolve()
		})
	}
	private toFixed (value: any) {
		return parseFloat(value.toFixed(this.numScale))
	}
}
